// app/providers.tsx
"use client";

import { NotificationProvider } from "@/context/NotificationContext";
import { SidebarProvider } from "@/context/SidebarContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { SessionProvider } from "next-auth/react";

export default function Providers({ children }: { children: React.ReactNode }) {
    return (
        <SessionProvider>
            <ThemeProvider>
                <SidebarProvider>
                    <NotificationProvider>
                        {children}
                    </NotificationProvider>
                </SidebarProvider>
            </ThemeProvider>
        </SessionProvider>
    );
}
